class dom {

    static createElementFromHTML = (htmlString) => {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstChild;
    }
    static setStyle = (objId, propertyObject) => {
        const elem = document.getElementById(objId);
        if(elem)
        {
            for (var property in propertyObject) {
                elem.style[property] = propertyObject[property];
            }
        }
    }

    static hide = (id) => {
        let element = document.getElementById(id);
        if (element) {
            element.style.display = "none";
        }

    };

    static show = (id) => {
        let element = document.getElementById(id);
        if (element) {
            element.style.display = "block";
        }
    };
}

export default dom;